module.exports = __webpack_public_path__ + "img/cement_mpc_home@2x.ce66661a.png";